import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "d-md-none" };
const _hoisted_2 = { class: "d-none d-md-block" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Datepicker = _resolveComponent("Datepicker");
    const _component_el_date_picker = _resolveComponent("el-date-picker");
    const _component_label_form = _resolveComponent("label-form");
    return (_openBlock(), _createBlock(_component_label_form, null, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_Datepicker, {
                    modelValue: _ctx.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.value) = $event)),
                    range: "",
                    "enable-time-picker": false,
                    "month-change-on-scroll": false,
                    placeholder: "Start Date - End Date",
                    format: "dd MMM yyyy"
                }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.value) = $event)),
                    type: "daterange",
                    "start-placeholder": "Start date",
                    "end-placeholder": "End date",
                    style: { "width": "100% !important" }
                }, null, 8 /* PROPS */, ["modelValue"])
            ])
        ]),
        _: 1 /* STABLE */
    }));
}
